function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
/**
 * Determines whether the message is sent by the job tax assistant.
 *
 * @param {Message} message
 * List of messages.
 */
function isJobTaxAssistant(message) {
  return message.content.type === 'Assistant';
}

/**
 * Creates a message group.
 */
var createGroup = function createGroup(message, jobTaxAssistant) {
  if (isJobTaxAssistant(message) && jobTaxAssistant) {
    return {
      sender: jobTaxAssistant,
      messages: []
    };
  }
  return {
    sender: message.sender,
    messages: []
  };
};

/**
 * Creates messages groups from a flat list of messages.
 *
 * @param {Message[]} messages
 * List of messages.
 *
 * @param {object} jobTaxAssistant
 * Current job tax assistant instance if any.
 *
 * @return {object[]}
 * Message groups.
 */
export function createMessageGroups(messages, jobTaxAssistant) {
  messages = messages.filter(function (x) {
    return x.type;
  });
  var groups = [];

  // Skip work when there's no work to be done.
  if (!messages || messages.length === 0) {
    return groups;
  }
  var currentGroup, previousMessage;

  // Used to keep track of the message that a user had last seen.
  var seenByMap = new Map();
  var _iterator = _createForOfIteratorHelper(messages),
    _step;
  try {
    var _loop = function _loop() {
      var message = _step.value;
      if (!currentGroup) {
        currentGroup = createGroup(message, jobTaxAssistant);
        groups.push(currentGroup);
      }

      // Based on this message's sender and the previous one,
      // determines if we need to end the current group and start
      // a new one.
      var isNewSender = Boolean(previousMessage && previousMessage.message.sender !== message.sender);
      var isNonTextMessage = Boolean(message.content.type !== 'Text' || previousMessage && previousMessage.message.content.type !== 'Text');
      if (isNewSender || isNonTextMessage) {
        currentGroup.lastMessage = previousMessage;
        currentGroup = createGroup(message, jobTaxAssistant);
        groups.push(currentGroup);
      }

      // We need to attach extra shit on the message, which we
      // don't want on the original model.
      var newMessage = {
        message: message,
        seenBy: []
      };
      if (!currentGroup.firstMessage) {
        currentGroup.firstMessage = newMessage;
      }
      currentGroup.messages.push(newMessage);
      previousMessage = newMessage;

      // We don't yet have a way to indicate if a user has left a conversation.
      currentGroup.hasSenderLeftConversation = false;
      // For the particular case of the job tax assistant being in or out of the convo.
      if (currentGroup.sender === jobTaxAssistant) {
        currentGroup.hasSenderLeftConversation = jobTaxAssistant.isDepartingConversationMessage(message);
      }
      message.recipientStatus.filter(function (rs) {
        return rs.status === 'read' && !!rs.recipient;
      }).forEach(function (rs) {
        return seenByMap.set(rs.recipient, newMessage);
      });
    };
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      _loop();
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  currentGroup.lastMessage = previousMessage;

  // We now have the messages that recipients have last seen.
  // We attach that to each corresponding message.
  seenByMap.forEach(function (message, recipient) {
    return message.seenBy.push(recipient);
  });
  return groups;
}
//# sourceMappingURL=conversationUtil.js.map
